var render = function render(){var _vm=this,_c=_vm._self._c;return _c('on-click-outside',{attrs:{"do":_vm.hide}},[_c('div',{on:{"click":_vm.show}},[_vm._t("default"),_vm._v(" "),(_vm.expanded)?_c('popout',{attrs:{"placement":_vm.placement,"dropdown-class":_vm.dropdownClass},on:{"hide":function($event){_vm.showResults = false}}},[_vm._t("dropdown")],2):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }